import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Instagram, Facebook } from 'lucide-react';
import { LOGO_URL } from './data';
import { PayButton } from './PayButton';
import { useLanguage } from './i18n/LanguageContext';
import { LanguageToggle } from './i18n/LanguageToggle';
export function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const {
    t
  } = useLanguage();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className="fixed top-0 inset-x-0 z-50 bg-[#faf0e7] transition-shadow duration-500 shadow-[0_1px_18px_rgba(44,33,24,0.05)]" data-id="element-326" data-mp="9iqbg0qyrukr">
      <nav className="max-w-6xl mx-auto px-5 sm:px-8 flex items-center justify-between h-[4.5rem] sm:h-24" data-id="element-327" data-mp="1kzgj7ob1cugh">
        <a href="#inicio" className="flex items-center" aria-label={t.navAriaHome} data-id="element-328" data-mp="9opvzago0j14">
          <img src={LOGO_URL} alt="Ginger Briones Studio" className="h-16 sm:h-20 w-auto object-contain [mix-blend-mode:darken]" data-id="element-329" data-mp="enkfkemgibma" />
        </a>

        <ul className="hidden md:flex items-center gap-8" data-id="element-330" data-mp="jnoyscer1kg7">
          {t.nav.map(link => <li key={link.href} data-id="element-331" data-mp="om9xu8i9ly32">
              <a href={link.href} className="font-body text-[11px] tracking-[2px] uppercase text-mid transition-colors duration-300 hover:text-gold" data-id="element-332" data-mp="ol8bh7vstp61">
                {link.label}
              </a>
            </li>)}
        </ul>

        <div className="hidden md:flex items-center gap-3" data-id="element-333" data-mp="3s0cl4xllh3uo">
          <SocialIcon href="https://www.instagram.com/gbstudiony/" label="Instagram" scrolled={true} data-id="element-334" data-mp="vdymqbhc0ls">
            <Instagram className="w-4 h-4" strokeWidth={1.5} data-id="element-335" data-mp="5nnvyrexc2y3" />
          </SocialIcon>
          <SocialIcon href="https://www.facebook.com/GingerBrionesC5/?ref=PROFILE_EDIT_xav_ig_profile_page_web#" label="Facebook" scrolled={true} data-id="element-336" data-mp="34btgqt5o1b7v">
            <Facebook className="w-4 h-4" strokeWidth={1.75} data-id="element-337" data-mp="399mkzgnerv5i" />
          </SocialIcon>
          <LanguageToggle data-id="element-338" data-mp="319gnt27lkhui" />
          <PayButton data-id="element-339" data-mp="2wc6mao6xofqb" />
        </div>

        <div className="flex items-center gap-1.5 md:hidden" data-id="element-340" data-mp="2wb5cso5kg1ap">
          <a href="https://www.instagram.com/gbstudiony/" aria-label="Instagram" className="p-2 text-champagne-deep transition-colors hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne-deep focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]" data-id="element-341" data-mp="3b132j8j58z20">
            <Instagram className="w-4 h-4" strokeWidth={1.5} data-id="element-342" data-mp="2ddcano2rnved" />
          </a>
          <LanguageToggle data-id="element-343" data-mp="2dff9mxlwcyv8" />
          <PayButton className="ml-0.5" data-id="element-344" data-mp="2sabovus4imht" />
          <button onClick={() => setOpen(true)} className="p-2 text-dark transition-colors hover:text-champagne-deep focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne-deep focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]" aria-label={t.navOpenMenu} data-id="element-345" data-mp="2sbcyrvxel2xy">
            <Menu className="w-6 h-6" strokeWidth={1.5} data-id="element-346" data-mp="2khrlm6ybvw9" />
          </button>
        </div>
      </nav>

      <AnimatePresence data-id="element-347" data-mp="a40tparw0fup">
        {open && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setOpen(false)} className="fixed inset-0 bg-dark/40 backdrop-blur-sm z-40 md:hidden" data-id="element-348" data-mp="f3vj19w0kxdn" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'tween',
          duration: 0.35,
          ease: [0.22, 1, 0.36, 1]
        }} className="fixed top-0 right-0 bottom-0 w-[78%] max-w-xs bg-cream z-50 md:hidden flex flex-col p-7" data-id="element-349" data-mp="56h5bi1h6mp1">
              <div className="flex items-center justify-between mb-10" data-id="element-350" data-mp="o4blcg10tygx">
                <img src={LOGO_URL} alt="Ginger Briones Studio" className="h-14 w-auto object-contain [mix-blend-mode:darken]" data-id="element-351" data-mp="o2gwiqmmpm7k" />
                <button onClick={() => setOpen(false)} className="p-2 text-mid" aria-label={t.navCloseMenu} data-id="element-352" data-mp="1gkmbmhp5v8nj">
                  <X className="w-6 h-6" strokeWidth={1.5} data-id="element-353" data-mp="3p2gmjy1yq8cl" />
                </button>
              </div>

              <ul className="flex flex-col gap-1" data-id="element-354" data-mp="3k2kr4n7bzp8n">
                {t.nav.map((link, i) => <motion.li key={link.href} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.1 + i * 0.06
            }} data-id="element-355" data-mp="3f3r9cil0hc2o" data-mpi={i}>
                    <a href={link.href} onClick={() => setOpen(false)} className="block py-3 font-serif text-2xl text-dark hover:text-gold transition-colors border-b border-brand-border/50" data-id="element-356" data-mp="bmiyiiopbchg">
                      {link.label}
                    </a>
                  </motion.li>)}
              </ul>

              <div className="mt-8" data-id="element-357" data-mp="3u0idf55mrbym">
                <LanguageToggle offsetColor="focus-visible:ring-offset-cream" data-id="element-358" data-mp="udiewvi4rdz4" />
              </div>

              <div className="mt-auto flex items-center gap-4 pt-8" data-id="element-359" data-mp="pmtqxq5nsz4q">
                <a href="https://www.instagram.com/gbstudiony/" aria-label="Instagram" className="w-11 h-11 rounded-full border border-champagne-deep/60 flex items-center justify-center text-champagne-deep hover:bg-champagne hover:text-dark transition-colors" data-id="element-360" data-mp="plin5qc7rrdm">
                  <Instagram className="w-5 h-5" strokeWidth={1.5} data-id="element-361" data-mp="2h9yol1j8m92d" />
                </a>
                <a href="https://www.facebook.com/GingerBrionesC5/?ref=PROFILE_EDIT_xav_ig_profile_page_web#" aria-label="Facebook" className="social-icon-elevation flex h-11 w-11 items-center justify-center rounded-full border border-champagne-deep/60 text-champagne-deep transition-colors hover:bg-champagne hover:text-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne-deep focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-362" data-mp="2m9ulyhxfj28y">
                  <Facebook className="w-5 h-5" strokeWidth={1.75} data-id="element-363" data-mp="351ngwhw26xjb" />
                </a>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </header>;
}
function SocialIcon({
  href,
  label,
  scrolled,
  children
}: {
  href: string;
  label: string;
  scrolled: boolean;
  children: React.ReactNode;
}) {
  const baseClassName = 'flex h-9 w-9 items-center justify-center rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne-deep focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]';
  const appearanceClassName = scrolled ? 'text-champagne-deep transition-colors duration-300 hover:text-champagne' : 'text-warm-white transition-colors duration-300 hover:text-gold-light';
  return <a href={href} aria-label={label} className={`${baseClassName} ${appearanceClassName}`} data-id="element-364" data-mp="1tk3sacwq45jt">
      {children}
    </a>;
}